import { SYS_SPACE_FIXED_50 } from '@oneaudi/unified-web-common';
import { NavigationBar } from '@oneaudi/unified-web-components';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledContainer = styled.div`
  z-index: 90;
  background-color: ${(props) =>
    process.env.IS_LEGACY ? props.theme.colors.background : props.theme.colors.colorCanvas200};
  height: 56px;
  position: sticky;
  top: 0;
  padding: 0;
`;
export const StyledNavigationBar = styled(NavigationBar)`
  padding: ${SYS_SPACE_FIXED_50} var(--page-margin);
`;

export const CustomGlobalStyle = createGlobalStyle`
  html {
    scroll-behaviour: smooth;
  }
  [id] {
    scroll-margin-top: 56px;
  }
  `;
